import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.paused-users', {
        url: '/paused-users',
        component: 'companyUserDirectoriesSaaspassUsersPausedUsers',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/paused-users/paused-users.state.js